import { Pipe, PipeTransform } from '@angular/core';
import { Schedule } from '@app/features/horaires/schedules.model';
import { ScheduleWeeklyDurationPipe } from './schedule-weekly-duration-pipe';

@Pipe({
  name: 'scheduleMonthlyDuration',
  standalone: true,
})
export class ScheduleMonthlyDurationPipe implements PipeTransform {
  transform(value: Schedule[]): string {
    const weeklyDuration = new ScheduleWeeklyDurationPipe().transform(value);
    if (weeklyDuration === '00:00') {
      return '00:00';
    }
    const [weeklyHours, weeklyMinutes] = weeklyDuration.split(':').map(Number);
    const yearlyHours = weeklyHours * 52;
    const yearlyMinutes = weeklyMinutes * 52;
    const yearlyTotalMinutes = yearlyHours * 60 + yearlyMinutes;

    const monthlyHours = Math.floor(yearlyTotalMinutes / 60 / 12);
    const monthlyMinutes = Math.floor((yearlyTotalMinutes / 12) % 60);
    return `${monthlyHours.toString().padStart(2, '0')}:${monthlyMinutes.toString().padStart(2, '0')}`;
  }
}
